export const normalizeModelKey = (model) => {
  const value = (model ?? '').toString().trim();
  return value ? value.toLowerCase() : '';
};

export const normalizeModelValue = (model) => (model ?? '').toString().trim();

export const formatModelOptions = (items) => {
  const map = new Map();
  items.forEach(item => {
    const value = normalizeModelValue(item?.value);
    if (!value) return;
    const key = normalizeModelKey(value);
    if (map.has(key)) return;
    const label = normalizeModelValue(item?.label) || value;
    const description = normalizeModelValue(item?.description);
    map.set(key, { value, label, description, suffix: value });
  });
  return Array.from(map.values());
};

export const resolveModelOption = (rawModel, modelOptions) => {
  const normalized = normalizeModelKey(rawModel);
  if (!normalized || modelOptions.length === 0) return null;
  return modelOptions.find(option =>
    [option.value, option.suffix, option.label]
      .map(normalizeModelKey)
      .includes(normalized)
  ) || null;
};
